'use client';
import { useFormContext } from 'react-hook-form';
import { cn } from '../../utils';
import DateInput, { type DateInputProps } from '../components/DateInput';
import { FormControl } from './FormControl';

export function FormDateInput({
  name,
  label,
  className,
  ...props
}: {
  name: string;
  label: string;
  className?: string;
} & DateInputProps) {
  const { register, getValues, formState, setValue } = useFormContext();

  return (
    <FormControl label={label} name={name}>
      <DateInput
        {...props}
        disabled={props.disabled || formState.isSubmitting}
        className={cn('w-full', className)}
        {...register(name)}
        value={getValues(name)}
        onChange={(e) => {
          register(name).onChange(e);
          setValue(name, e.target.value);
        }}
      />
    </FormControl>
  );
}
